module.exports = "/fonts/vendor/typeface-inter/files/inter-latin-400.woff?41e86578ed11f2de28bc5e90b5b322f2";